import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
@NgModule({
  declarations: [
    // CheckboxComponent,
    //    IconsComponent, 
  ],
  imports: [
    CommonModule
  ]
})
export class TableHeaderButtonModule { }
